var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMetamask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427319147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.5303 3.56567L17.5366 10.9881L19.3847 6.60899L27.5303 3.56567Z",
    fill: "#E2761B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.4594 3.56567L14.3728 11.0585L12.6151 6.60899L4.4594 3.56567ZM23.9346 20.7709L21.273 24.8488L26.9679 26.4156L28.605 20.8613L23.9346 20.7709ZM3.40479 20.8613L5.0319 26.4156L10.7268 24.8488L8.06517 20.7709L3.40479 20.8613Z",
    fill: "#E4761B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.4053 13.8808L8.81836 16.2813L14.4731 16.5324L14.2722 10.4558L10.4053 13.8808ZM21.5842 13.8808L17.6671 10.3855L17.5365 16.5324L23.1812 16.2813L21.5842 13.8808ZM10.7267 24.8488L14.1216 23.1915L11.1887 20.9015L10.7267 24.8488ZM17.868 23.1915L21.2728 24.8488L20.8008 20.9015L17.868 23.1915Z",
    fill: "#E4761B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.2732 24.8487L17.8683 23.1914L18.1395 25.4111L18.1093 26.3452L21.2732 24.8487ZM10.7271 24.8487L13.8909 26.3452L13.8708 25.4111L14.1219 23.1914L10.7271 24.8487Z",
    fill: "#D7C1B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.9408 19.4351L11.1084 18.6015L13.1071 17.6875L13.9408 19.4351ZM18.0488 19.4351L18.8824 17.6875L20.8912 18.6015L18.0488 19.4351Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.7271 24.8487L11.2092 20.7709L8.06543 20.8613L10.7271 24.8487ZM20.7911 20.7709L21.2732 24.8487L23.9349 20.8613L20.7911 20.7709ZM23.1816 16.2812L17.5369 16.5323L18.0592 19.435L18.8928 17.6874L20.9016 18.6014L23.1816 16.2812ZM11.1087 18.6014L13.1175 17.6874L13.9411 19.435L14.4735 16.5323L8.81873 16.2812L11.1087 18.6014Z",
    fill: "#CD6116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.81836 16.2812L11.1887 20.9015L11.1084 18.6014L8.81836 16.2812ZM20.9012 18.6014L20.8008 20.9015L23.1812 16.2812L20.9012 18.6014ZM14.4731 16.5323L13.9408 19.435L14.6037 22.86L14.7543 18.3503L14.4731 16.5323ZM17.5365 16.5323L17.2653 18.3403L17.3858 22.86L18.0588 19.435L17.5365 16.5323Z",
    fill: "#E4751F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.0588 19.435L17.3859 22.86L17.868 23.1914L20.8008 20.9014L20.9012 18.6013L18.0588 19.435ZM11.1084 18.6013L11.1888 20.9014L14.1216 23.1914L14.6037 22.86L13.9408 19.435L11.1084 18.6013Z",
    fill: "#F6851B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.1093 26.3452L18.1395 25.4111L17.8884 25.1901H14.1018L13.8708 25.4111L13.8909 26.3452L10.7271 24.8486L11.8319 25.7526L14.0717 27.3094H17.9185L20.1684 25.7526L21.2732 24.8486L18.1093 26.3452Z",
    fill: "#C0AD9E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M17.8681 23.1916L17.386 22.8601H14.6038L14.1217 23.1916L13.8706 25.4113L14.1016 25.1903H17.8882L18.1393 25.4113L17.8681 23.1916Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M27.9522 11.4703L28.8059 7.37233L27.5303 3.56567L17.868 10.737L21.5843 13.8808L26.8373 15.4175L28.0024 14.0616L27.5002 13.7L28.3037 12.9668L27.681 12.4847L28.4845 11.872L27.9522 11.4703ZM3.19385 7.37233L4.04758 11.4703L3.50521 11.872L4.30873 12.4847L3.69604 12.9668L4.49956 13.7L3.99736 14.0616L5.15242 15.4175L10.4054 13.8808L14.1217 10.737L4.45938 3.56567L3.19385 7.37233Z",
    fill: "#763D16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M26.8373 15.4174L21.5843 13.8807L23.1813 16.2812L20.8009 20.9014L23.9346 20.8612H28.605L26.8373 15.4174ZM10.4054 13.8807L5.15243 15.4174L3.40479 20.8612H8.06517L11.1888 20.9014L8.81847 16.2812L10.4054 13.8807ZM17.5366 16.5323L17.8681 10.7369L19.3947 6.60889H12.6151L14.1217 10.7369L14.4732 16.5323L14.5937 18.3603L14.6038 22.86H17.386L17.406 18.3603L17.5366 16.5323Z",
    fill: "#F6851B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetamask);
export default __webpack_public_path__ + "static/media/icon-metamask.c534abba96024e7d885bb930bd6f72c0.svg";
export { ForwardRef as ReactComponent };